<template>
  <div class="moderator-submit content-item">
    <div>
      <div class="leftadjust">
        <a-col :span="24">
          <iframe :src="instructionVideo('P_MODERATOR_VIDEO_LINK')" width="640" height="300" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
        </a-col>

        <!-- <a-row style="margin-top: 2rem;">
          <a-col class="text-center">
            <a class="tf-text-primary text-underline" :href="'https://truelifeorg.s3.amazonaws.com/assets/Moderator+Printout.pdf'" download="Moderator+Printout.pdf" target="_blank">
              Download Moderator Guide
            </a>
          </a-col>
        </a-row> -->

        <h3 class="text-underline">
          Agreement
        </h3>
        <p>
          Moderators have a very important task to accomplish as we work to make sure that whatever videos are being approved by us will also be approved on major social media outlets. One mistake
          could block <a class="text-underline" href="https://truelife.org" target="_blank">TrueLife.org</a> links from being posted permanently.
        </p>
        <p>
          Remember, we are under social media’s restrictions for what can be said. We have to safeguard videos from talking about politics or politicians, covid, vaccinations, treatments such as
          Ivermectin, divisive political issues and social issues. We have to make sure nothing is said that could be considered fake news, even if it isn’t. Keeping people focused only on their
          testimony will help prevent most of these problems.
        </p>
        <p>
          There is more freedom on social media when someone shares their own testimony. For example, they can say, “When I was a Muslim I didn’t know how wrong I was until I believed in Jesus. Or
          even, “I was a practicing homosexual until I became a Christian and then I realized God didn’t want me to do that anymore.” They cannot say, “I was healed from covid with Ivermectin.”
          Unfortunately, while that may be true, that would get <a class="text-underline" href="https://truelife.org" target="_blank">TrueLife.org</a> banned and Share Your Story’s reach would be
          negatively impacted.
        </p>
        <p>
          If you agree to hold to these standards you can apply here to become a moderator.
        </p>
        <p>
          If you agree to these terms please provide us with your phone number, which will only be used for your phone interview, and sign below:
        </p>
      </div>
      <p class="text-underline">
        <strong>
          Please click and draw your signature in the box blow.
        </strong>
      </p>
      <a-row :gutter="20">
        <a-col :md="{ span: 24, offset: 0 }" :xl="{ span: 12, offset: 0 }">
          <signature-pad ref="signature" name="signature" :showClear="false" class="mt-4" />
        </a-col>
        <a-col :md="{ span: 24, offset: 0 }" :xl="{ span: 12, offset: 0, offsetY: 4 }" style="margin-top: 72px;">
          <a-form :form="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
            <a-form-item label="Phone Number">
              <a-input v-decorator="['phone_number', { rules: [{ required: true, message: 'Phone Number is required!' }] }]" />
            </a-form-item>
            <a-row>
              <a-col :span="24" :style="{ textAlign: 'center', display: 'flex', justifyContent: 'space-around' }">
                <a-button type="danger" class="tf-btn tf-btn-danger" @click="doClear">
                  Clear
                </a-button>
                <a-button type="primary" class="tf-btn tf-btn-primary" :style="{ marginLeft: '8px' }" html-t @click="doSubmit">
                  Submit
                </a-button>
              </a-col>
            </a-row>
          </a-form>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import store from '@/store';
import SignaturePad from '@/components/SignaturePad';
import ModeratorService from '@/services/ModeratorService';
import UserService from '@/services/UserService';
import AdminService from '@/services/AdminService';
import { mapActions } from 'vuex';
export default {
  components: {
    SignaturePad,
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'moderatorForm' }),
    };
  },
  methods: {
    ...mapActions({
      openInstructionVideo: 'openInstructionVideo',
    }),
    async doSubmit() {
      const { data, isEmpty } = this.$refs.signature.submit();
      if (!isEmpty) {
        this.form.validateFields(async (err, values) => {
          if (!err) {
            let { moderator } = store.state.user.user;

            if (moderator && moderator.status === 'invited') {
              await AdminService.moderator.update(moderator.id, {
                signature: data,
                status: 'approved',
                phone_number: values.phone_number,
              });
            } else {
              await ModeratorService.doModeratorRequest({
                signature: data,
                phone_number: values.phone_number,
              });
            }

            const userInfos = await UserService.doGetUserInfo1();
            moderator = userInfos.moderator;

            store.dispatch('updateUser', {
              user: {
                ...store.state.user.user,
                moderator,
              },
            });

            const status = moderator.status;
            if (status === 'approved') {
              // Temporary solution to take of the weekend
              await this.$router.push({ name: 'videoReview' });
              this.$router.go(0);
            } else {
              this.$emit('onSubmit', status);
            }
          }
        });
      }
    },
    doClear() {
      this.$refs.signature.clear();
      this.form.resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
.content-item {
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  > div {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;

    > div {
      width: 100%;
      text-align: left;
      &:first-child {
        width: auto;
      }
    }
  }

  > button {
    margin-top: -36px;
    margin-left: 120px;
    text-transform: capitalize;
  }

  .open-instruction-video {
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    line-height: 16px;
    font-size: 14px;
    font-weight: 600;
    color: #637381;
    text-decoration: none;
    margin-bottom: 2rem;

    & > span {
      margin-left: 8px;
    }
  }

  .leftadjust {
    padding: 0;
    padding-top: 1rem;
  }

  .text-underline {
    text-decoration: underline;
  }
}
</style>
